
export function getLanguage() {
    let language = "el";
    if(localStorage.getItem("language") && localStorage.getItem("language") !== ""){
        language = localStorage.getItem("language");
    }
    return language;
}

export function translate(language, word) {
    const TRANSLATION = {
        "en": {
            "Print": "Print",
            "Nothing Found": "Nothing Found",
            "Event Info":"Event Info",
            "Visit Event Site": "Visit Event Site",
            "SearchInput": "Search",
            "All": "All ports",

            "The Best Ferry Guide for Greece...": "The Best Ferry Guide for Greece...",
            "The most reliable guide for your trips in Greek Islands. All ferry routes, info for ferry companies and travel agencies, booking services for ferries and hotels. The most valid info by LIKNOSS systems and the Greek ferry industry.": "The most reliable guide for your trips in Greek Islands. All ferry routes, info for ferry companies and travel agencies, booking services for ferries and hotels. The most valid info by LIKNOSS systems and the Greek ferry industry.",
            "Atthidon 4,176 71 Kallithea":"318, Mesogeion Ave, Agia Paraskevi",
            "Tel.: +30 211 95.58.800": "Tel.: +30 211 95.58.800",
            "Fax: +30 211 95.59.909": "Fax: +30 211 95.59.909",

            "Company name": "Company name",
            "First name": "First name",
            "Last name": "Last name",
            "Region": "Region",
            "Phone number": "Phone number",
            "Email": "Email",
            "Your comment": "Your comment",
            "Submit": "Submit" ,

            "Terms of Use": "Terms of Use",
            "Contact Us": "Contact Us",
            "Send Request": "Send Request",            
            "Contact Information": "Contact Information",
            "Name/Surname": "Name/Surname",
            "E-Mail Address": "E-Mail Address",
            "Contact Telephone": "Contact Telephone",
            "Company type": "Company type",
            "Company": "Compnay",
            "Company type (e.g Travel Agency)": "Company type (e.g Travel Agency)",
            "Advertisement valid period": "Advertisement valid period",
            "Date from": "Date from",
            "Date to": "Date to",
            "Date": "Date",
            "Notes": "Notes",
            "Availability for contact":"Availability for contact",
            "Weekday mornings":"Weekday mornings",
            "Weekday afternoons":"Weekday afternoons",
            "Advertisement Creation":"Advertisement Creation",
            "I already have a banner":"I already have a banner",
            "I would like a new banner, to be created":"I would like a new banner, to be created",
            "Contact us Telephone: +302119558800": "Contact us Telephone: +302119558800",
            "Email: adv@openseas.gr":"Email: adv@openseas.gr",
            "Interest Form": "Interest Form",
            "Contact Form": "Contact Form",

            "Advertise with us": "Advertise with us",
            "Research you next travel agency! Pick country, region or municipality and organise your next trip today!": "Research you next travel agency! Pick country, region or municipality and organise your next trip today!",
            "Learn about events, concerts, theatrical performances, local traditional festivals, festivals, children's activities at the destination of your choice.": "Learn about events, concerts, theatrical performances, local traditional festivals, festivals, children's activities at the destination of your choice.",
            "Advertise with us and promote your business activity to thousands of users visiting OpenSeas daily.": "Advertise with us and promote your business activity to thousands of users visiting OpenSeas daily.",
            "Collapse": "Collapse",
            "Departure":"Departure",
            "Arrival":"Arrival",
            "Round Trip":"Round Trip",
            "Departure Date":"Departure Date",
            "Return Date":"Return Date",
            "Clear Search":"Clear Search",
            "Search":"SEARCH",
            "Events":"Events",
            "Agencies":"Agencies",
            "Itineraries":"Itineraries",
            "Name":"Name",
            "Address":"Address",
            "Phone":"Phone",
            "Fax":"Fax",
            "Country":"Country",
            "ALL COUNTRIES":"ALL COUNTRIES",
            "Municipality":"Municipality",
            "Prefecture":"Prefecture",
            "All Destinations":"All Destinations",
            "All Event Types":"All Event Types",
            "Show Map":"Show Map",
            "Show Info":"Show Info",
            "Event Page":"Event Page",
            "Select Travel Dates":"Select Travel Dates",
            "Departure": "Departure",
            "There are no available itineraries for the selected day":"There are no available itineraries for the selected day",
            "Please select an itinerary to proceed":"Please select an itinerary to proceed",
            "Continue to booking":"Continue to booking",
            "Select":"Select",
            "Selected":"Selected",
            "Return":"Return",
            "Departure Time":"Departure Time",
            "Arrival Time":"Arrival Time",
            "Route Analysis":"Route Analysis",
            "Vessel kind":"Vessel kind",
            "Vessel": "Vessel",
            "Route":"Route",
            "Trip Duration":"Trip Duration",
            "Booking Agencies":"Booking Agencies",
            "Cabins":"Cabins",
            "Online Ferry Booking":"Online Ferry Booking",
            "Back":"Back",
            "Expand":"Expand",
            "Close":"Close",
            "Your online travel guide to the Mediterranean ferry routes. All ferry routes in Greece, the surrounding countries (Italy, Turkey, Albania) and the major routes in the Mediterranean.":"Your online travel guide to the Mediterranean ferry routes. All ferry routes in Greece, the surrounding countries (Italy, Turkey, Albania) and the major routes in the Mediterranean.",
            "The most up-to-date information on ferry routes, is at your entire disposal, through the LIKNOSS’ and the Ferry Companies’ reservation systems.":"The most up-to-date information on ferry routes, is at your entire disposal, through the LIKNOSS’ and the Ferry Companies’ reservation systems.",
            "This is an informative site, but allows you to redirect to the online booking engines of the Ferry Companies and of the Travel Agencies, after you have selected the desirable ferry route.":"This is an informative site, but allows you to redirect to the online booking engines of the Ferry Companies and of the Travel Agencies, after you have selected the desirable ferry route.",
            "For ticket issuance or for additional information, you may choose from the \"Travel Agencies\" section, the agency of your choice.":"For ticket issuance or for additional information, you may choose from the \"Travel Agencies\" section, the agency of your choice.",
        },
        "el": {
            "Print": "Εκτύπωση",
            "Nothing Found": "Δε βρέθηκαν αποτελέσματα",
            "Event Info":"Event Info",
            "Visit Event Site": "Visit Event Site",
            "SearchInput": "Αναζητηση",
            "All": "Όλα τα λιμάνια",

            "The Best Ferry Guide for Greece...": "Στην υπηρεσία των νησιών μας...",
            "The most reliable guide for your trips in Greek Islands. All ferry routes, info for ferry companies and travel agencies, booking services for ferries and hotels. The most valid info by LIKNOSS systems and the Greek ferry industry.": "On-line οδηγός για τα ταξίδια σας στις Ελληνικές Θάλασσες. Όλα τα δρομολόγια πλοίων, πληροφορίες εταιρειών και γραφείων, κρατήσεις εισιτηρίων, πλοίων/ξενοδοχείων. Τα πιο ενημερωμένα στοιχεία στην διάθεσή σας από τις εφαρμογές κρατήσεων της LIKNOSS και την ελληνική ακτοπλοΐα.",
            "Atthidon 4,176 71 Kallithea":"Μεσογείων 318 Αγία Παρασκευή",
            "Tel.: +30 211 95.58.800": "Τηλ: +30 211 95.58.800",
            "Fax: +30 211 95.59.909": "Φαξ: +30 211 95.59.909",

            "Company name": "Όνομα επιχείρησης",
            "First name": "Όνομα",
            "Last name": "Επώνυμο",
            "Region": "Περιοχή",
            "Phone number": "Τηλέφωνο",
            "Email": "Email",
            "Your comment": "Το σχόλιο σου",
            "Submit": "Υποβολή" ,

            "Terms of Use": "Οροι χρησης",
            "Contact Us": "Επικοινωνια",
            "Send Request": "Στείλε αίτημα",
            "Contact Information": "Στοιχεία επικοινωνίας",
            "Name/Surname": "Ονοματεπώνυμο",
            "E-Mail Address": "Διεύθυνση Email",
            "Contact Telephone": "Τηλέφωνο επικοινωνίας",
            "Company type": "Είδος Επιχείρησης",
            "Company": "Εταιρεία",
            "Company type (e.g Travel Agency)": "Είδος Επιχείρησης (π.χ. Τουριστικό Γραφείο)",
            "Advertisement valid period": "Περίοδος Εμφάνισης Διαφήμισης",
            "Date from": "Ημερομηνία από",
            "Date to": "Ημερομηνία μέχρι",
            "Date": "Ημερομηνία",
            "Notes": "Σημειώσεις",
            "Availability for contact":"Διαθεσιμότητα για επικοινωνία",
            "Weekday mornings":"Καθημερινές Πρωί",
            "Weekday afternoons":"Καθημερινές Απόγευμα",
            "Advertisement Creation":"Δημιουργία Διαφήμισης",
            "I already have a banner":"Έχω ήδη έτοιμο banner",
            "I would like a new banner, to be created":"Θα ήθελα να δημιουργηθεί banner",
            "Contact us Telephone: +302119558800": "Επικοινωνήστε μαζί μας: +302119558800",
            "Email: adv@openseas.gr":"Email: adv@openseas.gr",
            "Interest Form": "Φόρμα Ενδιαφέροντος",
            "Contact Form": "Φόρμα Επικοινωνίας",
            
            "Advertise with us": "Διαφημιστειτε μαζι μας",
            "Research you next travel agency! Pick country, region or municipality and organise your next trip today!": "Αναζητήστε το ταξιδιωτικό γραφείο που θέλετε. Επιλέξτε χώρα, νομό ή δήμο και Οργανώστε το επόμενο σας ταξίδι σήμερα!",
            "Learn about events, concerts, theatrical performances, local traditional festivals, festivals, children's activities at the destination of your choice.": "Ενημερωθείτε για εκδηλώσεις, συναυλίες, θεατρικές παραστάσεις, τοπικές παραδοσιακές γιορτές, φεστιβάλ, δραστηριότητες για παιδιά στον προορισμό της επιλογής σας.",
            "Advertise with us and promote your business activity to thousands of users visiting OpenSeas daily.": "Διαφημιστείτε μαζί μας και προωθείστε την δραστηριότητα της επιχείρησής σας στους χιλιάδες χρήστες που επισκέπτονται το OpenSeas καθημερινά.",
            "Collapse": "Κλείσιμο",
            "Departure":"Αναχώρηση",
            "Arrival":"Άφιξη",
            "Round Trip":"Με Επιστροφή",
            "Departure Date":"Ημ. Αναχώρησης",
            "Return Date":"Ημ. Επιστροφής",
            "Clear Search":"Καθαρισμός",
            "Search":"ΑΝΑΖΗΤΗΣΗ",
            "Events":"Εκδηλωσεις",
            "Agencies":"Ταξιδιωτικα Γραφεια",
            "Itineraries":"Δρομολόγια",
            "Name":"Όνομα",
            "Address":"Διεύθυνση",
            "Phone":"Τηλέφωνο",
            "Fax":"Φαξ",
            "Country":"Χώρα",
            "ALL COUNTRIES":"Όλες οι χώρες",
            "Municipality":"Δήμος",
            "Prefecture":"Νομός",
            "All Destinations":"Όλοι οι προορισμοί",
            "All Event Types":"Όλοι οι τύποι εκδηλώσεων",
            "Show Map":"Χάρτης",
            "Show Info":"Πληροφορίες",
            "Event Page":"Σελίδα εκδήλωσης",
            "Select Travel Dates":"Επιλέξτε ημερομηνίες ταξιδίου",
            "Departure":"Αναχώρηση",
            "There are no available itineraries for the selected day":"Δεν υπάρχουν διαθέσιμα δρομολόγια για την επιλεγμένη ημερομηνία",
            "Please select an itinerary to proceed":"Παρακαλώ επιλέξτε ένα δρομολόγιο για να προχωρήσετε",
            "Continue to booking":"Προχωρήστε σε κράτηση",
            "Select":"Επιλέξτε",
            "Selected":"Επιλέχθηκε",
            "Return":"Επιστροφή",
            "Departure Time":"Ώρα Αναχώρησης",
            "Arrival Time":"Ώρα Άφιξης",
            "Route Analysis":"Ανάλυση Διαδρομής",
            "Vessel kind":"Είδος Πλοίου",
            "Vessel": "Πλοίο",
            "Route":"Διαδρομή",
            "Trip Duration":"Διάρκεια Ταξιδίου",
            "Booking Agencies":"Κράτηση σε ιστοσελίδα Ταξιδιωτικού Γραφείου",
            "Cabins":"Καμπίνες",
            "Online Ferry Booking":"Κράτηση σε ιστοσελίδα Ακτοπλοϊκής Εταιρείας",
            "Back":"Πίσω",
            "Expand":"Περισσότερες Θέσεις",
            "Close":"Κλείσιμο",
            "Your online travel guide to the Mediterranean ferry routes. All ferry routes in Greece, the surrounding countries (Italy, Turkey, Albania) and the major routes in the Mediterranean.":"On-line οδηγός για τα ταξίδια σας στην Μεσόγειο. Όλα τα δρομολόγια πλοίων στην Ελλάδα, τις γύρω χώρες (Ιταλία, Τουρκία, Αλβανία ) και τα κυριότερα Δρομολόγια της Μεσογείου.",
            "The most up-to-date information on ferry routes, is at your entire disposal, through the LIKNOSS’ and the Ferry Companies’ reservation systems.":"Τα πιο ενημερωμένα στοιχεία είναι στη διάθεσή σας, από τις εφαρμογές κρατήσεων της LIKNOSS και των Ακτοπλοϊκών Εταιρειών.",
            "This is an informative site, but allows you to redirect to the online booking engines of the Ferry Companies and of the Travel Agencies, after you have selected the desirable ferry route.":"Η ιστοσελίδα αυτή είναι ενημερωτικού περιεχομένου, αλλά σας παρέχει την δυνατότητα ανακατεύθυνσης σε Online Μηχανές κρατήσεων εισιτηρίων Ακτοπλοϊκών Εταιρειών και Ταξιδιωτικών Γραφείων , μετά την επιλογή του επιθυμητού δρομολογίου.",
            "For ticket issuance or for additional information, you may choose from the \"Travel Agencies\" section, the agency of your choice.":"Για έκδοση εισιτηρίων ή περισσότερες πληροφορίες, μπορείτε να επιλέξετε από την ενότητα «Ταξιδιωτικά Γραφεία», το γραφείο που σας εξυπηρετεί και να ενημερωθείτε κατά περίπτωση. ",
        }, 
        "it" :{
            "Print": "Stampare",
            "Nothing Found": "Risultati non trovati",
            "Event Info":"Event Info",
            "Visit Event Site": "Visit Event Site",
            "SearchInput": "Cerca",
            "All": "Tutti i porti",

            "The Best Ferry Guide for Greece...": "La migliore guida per i traghetti in Grecia...",
            "The most reliable guide for your trips in Greek Islands. All ferry routes, info for ferry companies and travel agencies, booking services for ferries and hotels. The most valid info by LIKNOSS systems and the Greek ferry industry.": "La guida più affidabile per i viaggi nelle isole greche. Tutte le rotte e informazioni sulle compagnie di traghetti e agenzie di viaggio, servizio di prenotazione per traghetti e hotel. Le più valide informazioni fornite dai sistemi della LIKNOSS e dall’ industria dei traghetti greca.",
            "Atthidon 4,176 71 Kallithea":"318, Mesogeion Ave, Agia Paraskevi",
            "Tel.: +30 211 95.58.800": "Tel.: +30 211 95.58.800",
            "Fax: +30 211 95.59.909": "Fax: +30 211 95.59.909",

            "Company name": "Company name",
            "First name": "First name",
            "Last name": "Last name",
            "Region": "Region",
            "Phone number": "Phone number",
            "Email": "Email",
            "Your comment": "Your comment",
            "Submit": "Submit" ,

            "Terms of Use": "Termini e condizioni",
            "Contact Us": "Contattaci",
            "Send Request": "Invia Richiesta",
            "Contact Information": "Dati Utente",
            "Name/Surname": "Nome / Congnome",
            "E-Mail Address": "Indirizzo mail",
            "Contact Telephone": "Telefono",
            "Company type": "Tipo Azienda",
            "Company type (e.g Travel Agency)": "Tipo Azienda (ad es. Agenzia di viaggio)",
            "Company": "Azienda",
            "Advertisement valid period": "Periodo di validità pubblicità",
            "Date from": "Data da",
            "Date to": "Data fino",
            "Date": "Data",
            "Notes": "Note",
            "Availability for contact":"Disponibilità per il contatto",
            "Weekday mornings":"Tutti i giotni",
            "Weekday afternoons":"Tutti i pomeriggi ",
            "Advertisement Creation":"Creazione pubblicità",
            "I already have a banner":"Ho già un banner",
            "I would like a new banner, to be created":"Vorrei nuovo banner",
            "Contact us Telephone: +302119558800": "Contattaci al Telefono: +302119558800",
            "Email: adv@openseas.gr":"Email: adv@openseas.gr",

            "Advertise with us": "Fatte pubicità con noi",
            "Research you next travel agency! Pick country, region or municipality and organise your next trip today!": "Research you next travel agency! Pick country, region or municipality and organise your next trip today!",
            "Learn about events, concerts, theatrical performances, local traditional festivals, festivals, children's activities at the destination of your choice.": "Learn about events, concerts, theatrical performances, local traditional festivals, festivals, children's activities at the destination of your choice.",
            "Advertise with us and promote your business activity to thousands of users visiting OpenSeas daily.": "Advertise with us and promote your business activity to thousands of users visiting OpenSeas daily.",
            "Collapse": "Collapse",
            "Departure":"Partenza",
            "Arrival":"Arrivo",
            "Round Trip":"Andata/Ritorno",
            "Departure Date":"Data Partenza",
            "Return Date":"Data Ritorno",
            "Clear Search":"Cancella ricerca",
            "Search":"CERCA",
            "Events":"Eventi",
            "Agencies":"Agenzie",
            "Itineraries":"Itinerari",
            "Name":"Nome",
            "Address":"Indirizzo",
            "Phone":"Telefono",
            "Fax":"Fax",
            "Country":"Paese",
            "Municipality":"Città",
            "Prefecture":"Provincia",
            "All Destinations":"Tutte le destinazioni",
            "All Event Types":"Tutte le tipologie di eventi",
            "Show Map":"Mappa",
            "Show Info":"Informazioni",
            "Event Page":"Pagina Eventi",
            "Select Travel Dates":"Seleziona le date del viaggio",
            "Departure":"Partenza",
            "There are no available itineraries for the selected day":"Non ci sono itinerari per il giorno selezionato",
            "Please select an itinerary to proceed":"Seleziona un itinerario per procedere",
            "Continue to booking":"Continua per effettuare la prenotazione",
            "Select":"Seleziona",
            "Selected":"Selezionato",
            "Return":"Ritorno",
            "Departure Time":"Orario partenza",
            "Arrival Time":"Orario arrivo",
            "Route Analysis":"Dettagli itinerario",
            "Vessel kind":"Tipologia nave",
            "Vessel": "Nave",
            "Route":"Itinerario",
            "Trip Duration":"Durata Viaggio",
            "Booking Agencies":"Prenota tramite agenzia di viaggio",
            "Cabins":"Cabine",
            "Online Ferry Booking":"Prenota dal sistema della compagnia",
            "Back":"Indietro",
            "Expand":"Espandi",
            "Close":"Chiudi",
            "Your online travel guide to the Mediterranean ferry routes. All ferry routes in Greece, the surrounding countries (Italy, Turkey, Albania) and the major routes in the Mediterranean.":"La tua guida online per le rotte traghetti nel Mediterraneo. Tutte le rotte traghetti in Grecia e nei Paesi limitrofi (Italia, Turchia, Albania) e le principali rotte nel Mediterraneo.",
            "The most up-to-date information on ferry routes, is at your entire disposal, through the LIKNOSS’ and the Ferry Companies’ reservation systems.":"Le informazioni più aggiornate sulle rotte traghetti a tua completa disposizione tramite il sistema di prenotazione della LIKNOSS e delle compagnie marittime.",
            "This is an informative site, but allows you to redirect to the online booking engines of the Ferry Companies and of the Travel Agencies, after you have selected the desirable ferry route.":"Questo è un sito informativo ma ti permette, una volta selezionato l’itinerario desiderato, di essere reindirizzato al sistema di prenotazione online delle compagnie di traghetti e delle agenzie di viaggio.",
            "For ticket issuance or for additional information, you may choose from the \"Travel Agencies\" section, the agency of your choice.":"Per l’emissione biglietti o per maggiori informazioni puoi scegliere, dalla sezione “Agenzie di viaggio”, l’agenzia desiderata.",
        }
    }
    
    if(!language){
        language = "el"
    }
    let translated_word = TRANSLATION[`${language }`][`${word}`]
    if(!translated_word){
        translated_word = word;
    }
    return translated_word;
}


// WEBPACK FOOTER //
// ./src/components/Translation/Translation.js